//Page Tab Title
export const TabTitle=(newTitle:string)=>{
    return (document.title = newTitle);
}